module.exports = __webpack_public_path__ + "img/06.efab5bc2.jpg";